const Uint8ArrayFromHex = (hexString) => {
    const bytes = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
        bytes[i / 2] = parseInt(hexString.substring(i, i + 2), 16);
    }
    return bytes;
};

const Uint8ArrayFromBase64 = (base64) => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
};

const Uint8ArrayToBase64 = (bytes) => {
    let binaryString = '';
    for (let i = 0; i < bytes.length; i++) {
        binaryString += String.fromCharCode(bytes[i]);
    }
    return btoa(binaryString);
};

const getKey = async (exerciseId) => {
    const passwordBuffer = new TextEncoder().encode(exerciseId.toString());
    const saltBuffer = Uint8ArrayFromHex('FF1134');

    const keyMaterial = await window.crypto.subtle.importKey('raw', passwordBuffer, { name: 'PBKDF2' }, false, ['deriveKey']);

    // Deriva la chiave usando PBKDF2
    const derivedKey = await window.crypto.subtle.deriveKey(
        {
            name: 'PBKDF2',
            salt: saltBuffer,
            iterations: 312,
            hash: 'SHA-256',
        },
        keyMaterial,
        {
            name: 'AES-GCM',
            length: 256,
        },
        false,
        ['encrypt', 'decrypt'],
    );
    return derivedKey;
};

export const encryptExerciseList = async (exerciseId, exerciseData) => {
    try {
        // Converti i dati in stringa JSON
        const dataString = JSON.stringify(exerciseData);
        const dataBuffer = new TextEncoder().encode(dataString);

        // Importa la password come chiave per PBKDF2
        const derivedKey = await getKey(exerciseId);

        // Genera un IV casuale per AES-GCM
        const GCM_IV_LENGTH = 12;
        const iv = window.crypto.getRandomValues(new Uint8Array(GCM_IV_LENGTH));

        // Cripta usando AES-GCM
        const encryptedBuffer = await window.crypto.subtle.encrypt(
            {
                name: 'AES-GCM',
                iv: iv,
            },
            derivedKey,
            dataBuffer,
        );

        // Combina IV + dati criptati
        const encryptedData = new Uint8Array(iv.length + encryptedBuffer.byteLength);
        encryptedData.set(iv);
        encryptedData.set(new Uint8Array(encryptedBuffer), iv.length);

        // Converti in base64
        return Uint8ArrayToBase64(encryptedData);
    } catch (e) {
        console.error('Errore durante la crittografia:', e);
        return null;
    }
};

export const decryptExerciseList = async (exerciseId, exerciseList) => {
    const derivedKey = await getKey(exerciseId);

    // Decodifica i dati da base64
    const encryptedData = Uint8ArrayFromBase64(exerciseList);

    const GCM_IV_LENGTH = 12;
    // Per AES-GCM, i primi 12 bytes sono l'IV
    const iv = encryptedData.slice(0, GCM_IV_LENGTH);
    const ciphertextWithTag = encryptedData.slice(GCM_IV_LENGTH);

    // Decripta usando AES-GCM
    const decryptedBuffer = await window.crypto.subtle.decrypt(
        {
            name: 'AES-GCM',
            iv: iv,
        },
        derivedKey,
        ciphertextWithTag,
    );

    // Converti in stringa UTF-8
    const decryptedString = new TextDecoder('utf-8').decode(decryptedBuffer);

    return JSON.parse(decryptedString);
};
